module.exports = __webpack_public_path__ + "static/media/home_temp.9cf1999a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_temp.svg
// module id = 540
// module chunks = 0